// import { capitalize } from 'lodash';
export default function getLeagueName(league?: string) {
  if (!league) {
    return '';
  }

  const leagueNameMap: { [key: string]: string } = {
    superettan: 'Superettan',
    allsvenskan: 'Allsvenskan',
    damallsvenskan: 'OBOS Damallsvenskan',
    elitettan: 'Elitettan',
  };

  return leagueNameMap[league.toLowerCase()] || league;
}
